// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1aSm3","choiceBoxes":"toolbarselects_choiceBoxes__1Qd89","simpleField":"toolbarselects_simpleField__H_KON"};